import CcProductstock from "@/main/webapp/resources/src/vue/domain/productstock/cc-productstock";

export default class CcWishlist {
	private _uniqueId: string;
	private _name: string;
	private _privacy: string;
	private _productstocks: Array<CcProductstock>;
	private _user: string;

	constructor (uniqueId: string, name: string, privacy: string, productstocks: Array<CcProductstock>, user: string) {
		this._uniqueId = uniqueId;
		this._name = name;
		this._privacy = privacy;
		this._productstocks = productstocks;
		this._user = user;
	}

	get uniqueId (): string {
		return this._uniqueId;
	}

	set uniqueId (uniqueId: string) {
		this._uniqueId = uniqueId;
	}

	get name (): string {
		return this._name;
	}

	set name (name: string) {
		this._name = name;
	}

	get privacy (): string {
		return this._privacy;
	}

	set privacy (privacy: string) {
		this._privacy = privacy;
	}

	get productstocks (): Array<CcProductstock> {
		return this._productstocks;
	}

	set productstocks (productstocks: Array<CcProductstock>) {
		this._productstocks = productstocks;
	}

	get user (): string {
		return this._user;
	}

	set user (user: string) {
		this._user = user;
	}
}
